import { getHomepageSlug } from '@app/services/homepageRepository';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface Props {
  refetchOnMount?: boolean;
}

export const HOMEPAGE_QUERY_KEY = 'homepage';

export const useHomepage = ({ refetchOnMount }: Props = {}) => {
  const { t } = useTranslation(['cms']);

  return useQuery({
    meta: {
      errorMessage: t('cms:fetch_homepage_fail'),
    },
    queryFn: async () => getHomepageSlug(),
    queryKey: [HOMEPAGE_QUERY_KEY],
    refetchOnMount,
  });
};
